import {formatearDecimal} from '../util/util';

export const monto = {
    inserted(el, binding) {
        if (binding.value) {
            el.innerHTML = "S/ " + formatearDecimal(binding.value);
        } else{
            el.innerHTML = null
        }

    },
    update(el, binding) {
        if (binding.value) {
            el.innerHTML = "S/ " + formatearDecimal(binding.value);
        } else{
            el.innerHTML = null
        }
    }
};




// WEBPACK FOOTER //
// ./src/directives/montoSoles.js